import React, { useState } from 'react';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import Icon from '@/Shared/Icon';
import UserDropdown from '@/Shared/Layouts/Headers/UserDropdown';
import { useProps } from '@/Shared/FuncComp';

export default () => {
	const { auth } = useProps();
	// const [menuOpened, setMenuOpened] = useState(false);
	return (
		<div className="bg-white border-b w-full p-4 md:py-0 md:px-12 text-sm d:text-md flex justify-between items-center">
			<div className="mt-1 mr-4">{auth.user.account.name}</div>
			<UserDropdown />
		</div>
	);
};
